import Vue from 'vue'
import App from './App.vue'
import axios from './net/axios/axios'


// import style
import './styles/index.less';
import VueClipboards from 'vue-clipboards';


import VueRouter from 'vue-router';
import Routers from './router/router';

Vue.use(VueRouter);
Vue.use(VueClipboards);

// 路由配置
const RouterConfig = {
  mode: 'hash',
  routes: Routers
};
const router = new VueRouter(RouterConfig);
document.title = "笔落"
router.beforeEach((to, from, next) => {
  if (to.meta.title){
    document.title = to.meta.title
  }
  next();
});

router.afterEach((to, from, next) => {

  window.scrollTo(0, 0);
});

Vue.http = Vue.prototype.$http = axios;

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router: router,
  render: h => h(App)
}).$mount('#app');